export const iconFontAwesomeDevicesHardwareDisplay = (
	<i className="fa-solid fa-display"></i>
);
